<div class="pv-input">
	@if (label) {
		<ic-label [help]="help" [required]="required"> {{ label }} </ic-label>
	}
	<div class="border" [class.suffix]="suffix" [formGroup]="form">
		@if (isPending || icon) {
			<i aria-hidden="true" [class]="isPending ? pendingIcon : icon" [class.disabled]="disabled"> </i>
		}
		<input
			#input
			data-test="number-input"
			formControlName="value"
			type="number2"
			[attr.disabled]="disabled || null"
			[class]="inputClass"
			[distinguishNonNumericFromEmpty]="distinguishNonNumericFromEmpty"
			[max]="max"
			[min]="min"
			[placeholder]="placeholder"
			(blur)="onTouched()"
			(input)="onChange()"
		/>
		<span> {{ suffix }} </span>
	</div>
	<ng-content select=".errors" />
</div>
